<template>
  <div class="thread-discussion">
    <ol
      id="thread-discussion-list"
      class="thread-discussion__list"
    >
      <li
        v-for="(reply) in visibleReplies"
        :key="reply.id"
        data-test-id="thread-discussion-list-item"
      >
        <thread-reply
          :reply="reply"
          :thread="thread"
        />
      </li>
    </ol>
    <button
      v-if="showTruncatedReplies"
      class="thread-discussion__toggle text-button"
      :aria-expanded="isOpened ? 'true' : 'false'"
      aria-controls="thread-discussion-list"
      @click="showMoreReplies()"
    >
      {{ viewRepliesButtonText }}
      <icon-component
        name="caret"
        title="caret icon"
        class="thread-discussion__icon icon--small"
      />
    </button>
  </div>
</template>

<script>
import ThreadReply from '@/components/Thread/ThreadReply.vue';
import scrollToRouteHashMixin from '@/mixins/scroll-to-fragment-mixin';

export default {
  name: 'ThreadDiscussion',
  components: {
    ThreadReply,
  },
  mixins: [scrollToRouteHashMixin],
  props: {
    replies: {
      type: Array,
      required: true,
    },
    thread: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpened: false,
      truncatedLimit: 4,
    };
  },
  computed: {
    showTruncatedReplies() {
      return this.replies.length > this.truncatedLimit && !this.isOpened;
    },
    viewRepliesButtonText() {
      return `View ${this.replies.length - this.truncatedLimit} more replies`;
    },
    visibleReplies() {
      return this.showTruncatedReplies
        ? this.replies.slice(0, this.truncatedLimit)
        : this.replies;
    },
    routeHasReplyHash() {
      return this.$route.hash.match(/reply-/);
    },
  },
  created() {
    if (this.routeHasReplyHash) {
      this.showMoreReplies();
      window.setTimeout(this.scrollToRouteHash, 0);
    }
    this.$emit('loaded');
  },
  methods: {
    showMoreReplies() {
      this.isOpened = true;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_thread-discussion';
</style>

<docs>
A Thread that displays a list of thread replies in
chronological order starting from oldest to newest

</docs>
